import React from 'react';
import classNames from 'classnames';
import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import styles from './SessionStatItem.module.scss';

const TONE_CLASS = {
  warning: styles.pill_warning,
  success: styles.pill_success,
};

export const SessionStatItemComponent = ({
  icon,
  iconBg,
  label,
  value,
  percentText,
  percentTone,
}) => {
  return (
    <div className={styles.statItem}>
      <span
        className={styles.iconBadge}
        style={iconBg ? { background: `var(--${iconBg})` } : undefined}
      >
        {icon}
      </span>
      <div className={styles.statTextGroup}>
        <Text
          variant={textVariantsEnum.Text_xxs}
          fontWeight={fontWeightEnum.Medium}
          color="gray-500"
          className={styles.label}
        >
          {label}
        </Text>
        <Text
          variant={textVariantsEnum.Text_md}
          fontWeight={fontWeightEnum.Semibold}
          color="gray-900"
        >
          {value}
        </Text>
      </div>
      {percentText && (
        <span className={classNames(styles.pill, TONE_CLASS[percentTone])}>
          {percentText}
        </span>
      )}
    </div>
  );
};

SessionStatItemComponent.displayName = 'SessionStatItem';
